module.exports = __webpack_public_path__ + "static/media/oldLogo.e0b953af.svg";